import { render, staticRenderFns } from "./confirmDeleteDialog.vue?vue&type=template&id=a9cb8500&scoped=true&"
import script from "./confirmDeleteDialog.vue?vue&type=script&lang=tsx&"
export * from "./confirmDeleteDialog.vue?vue&type=script&lang=tsx&"
import style0 from "./confirmDeleteDialog.vue?vue&type=style&index=0&id=a9cb8500&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9cb8500",
  null
  
)

export default component.exports